import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { fetchSnakeByName } from '~/services/overview-widget/overview-widget-service';

const QUERY_KEY_FETCH_SNAKE_BY_NAME = 'QUERY_KEY_FETCH_SNAKE_BY_NAME';

export const useFetchSnakeByName = (
  snake: string,
  horizonNumberOfDays: number
) =>
  useQuery({
    queryKey: [QUERY_KEY_FETCH_SNAKE_BY_NAME, snake, horizonNumberOfDays],
    queryFn: ({ signal }) =>
      fetchSnakeByName(snake, horizonNumberOfDays, signal),
    select: data => {
      return {
        tsData: data.data?.result.data,
        meta: data.data?.meta,
      };
    },
    staleTime: getTimeTillEndOfDayMs(),
  });
